
export class Estado {
  constructor(public sigla: string,
              public nome: string,
              public cidades: string[]
              ){ }
}
